module.exports = __webpack_public_path__ + "static/img/8.3a68eff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/8.png
// module id = 0Wbx
// module chunks = 0